import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-heading font-bold text-sm">K</span>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-900">
                Kakobuy <span className="text-primary-500">Polska</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Niezależny przewodnik informacyjny o Kakobuy Spreadsheet. Znajdź najlepsze produkty, kategorie i porady zakupowe dla użytkowników z Polski.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              Szybkie linki
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#kategorie" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  Kategorie produktów
                </a>
              </li>
              <li>
                <a href="#jak-dziala" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  Jak to działa
                </a>
              </li>
              <li>
                <Link to="/artykul/kakobuy-spreadsheet-poradnik" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  Poradnik Kakobuy
                </Link>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* External Links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              Kakobuy Spreadsheet
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer inline-flex items-center gap-1"
                >
                  Kakobuy Spreadsheet
                  <i className="ri-external-link-line text-xs"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/category-911-Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer inline-flex items-center gap-1"
                >
                  Shoes
                  <i className="ri-external-link-line text-xs"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/search-912/name/Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer inline-flex items-center gap-1"
                >
                  Hoodies / Sweaters
                  <i className="ri-external-link-line text-xs"></i>
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              Informacje
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  O nas
                </a>
              </li>
              <li>
                <a href="#disclaimer" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  Disclaimer
                </a>
              </li>
              <li>
                <Link to="/artykul/kakobuy-spreadsheet-poradnik" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  Centrum bezpieczeństwa
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between mt-10 pt-6 border-t border-background-200/70 gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Kakobuy Polska. Wszelkie prawa zastrzeżone. Niezależny przewodnik informacyjny.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              Kakobuy Spreadsheet
            </a>
            <span className="text-foreground-300">·</span>
            <span className="text-xs text-foreground-500 whitespace-nowrap">
              kakobuypolska.bond
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}